<template>
  <CustomDashboardModuleItem>
    <template #title>{{ props.formModel.name }}</template>
    <template #actions>
      <OkrModuleActions
        v-if="!customDashboardState.isDragging"
        :can-edit
        :form-model
        :layout-id="layoutTypeId"
        @update:layout-id="onUpdateLayout"
      />
    </template>
    <template #content>
      <CustomDashboardOkrModuleContent
        :dashboard-item="dashboardItem"
        :form-model="formModel"
        is-readonly
      />
    </template>
  </CustomDashboardModuleItem>
</template>

<script setup>
import { computed, inject, onBeforeUnmount, onMounted, provide, watch } from 'vue'

import { tracker } from '@/tracking/amplitude'
import { EVENT_CATEGORIES, EVENT_SECTIONS } from '@/tracking/amplitude-helpers'
import {
  CUSTOM_DASHBOARD_MODULE_ATTRIBUTES,
  LAYOUT_NAMES_BY_TYPE_ID,
  MODULE_TYPE_IDS
} from '@/utils/custom-dashboard-helper'
import {
  currentModuleStateInjectionKey,
  customDashboardModulesStateInjectionKey,
  customDashboardStateInjectionKey
} from '@/utils/injection-keys'

import CustomDashboardModuleItem from '@/components/dashboard/custom-dashboard/CustomDashboardModuleItem'
import CustomDashboardOkrModuleContent from '@/components/dashboard/custom-dashboard/modules/CustomDashboardOkrModuleContent'
import OkrModuleActions from '@/components/dashboard/custom-dashboard/modules/moduleActions/OkrModuleActions'

defineOptions({
  name: 'CustomDashboardOkrModule'
})

const props = defineProps({
  formModel: {
    type: Object,
    default: () => ({})
  },

  dashboardItem: {
    type: Object,
    default: () => ({})
  },

  layoutTypeId: {
    type: [String, Number],
    default: null
  },

  canEdit: {
    type: Boolean
  }
})

/*const onUpdateLayout = async value => {
  try {
    const api = new CustomDashboardApiHandler()

    await api.updateModuleAttribute({
      layoutTypeId: value,
      id: props.dashboardItem.id,
      moduleId: props.formModel.id
    })
    emit('update:layoutTypeId', value)
  } catch (error) {
    handleError({ error })
  }
}*/

const customDashboardState = inject(customDashboardStateInjectionKey)
const modulesState = inject(customDashboardModulesStateInjectionKey)
const moduleId = computed(() => props.formModel.id)
const currentModuleState = computed(() => {
  return modulesState.value[moduleId.value] || {}
})

const onUpdateLayout = value => {
  modulesState.value.setModuleLayoutTypeId(moduleId.value, value)

  const mode = LAYOUT_NAMES_BY_TYPE_ID[value] || ''

  tracker.logEvent('custom dashboard updated', {
    category: EVENT_CATEGORIES.DASHBOARD,
    section: EVENT_SECTIONS.DASHBOARD,
    id: moduleId.value.id,
    mode: mode.toLowerCase()
  })
}

watch(
  () => props.formModel[CUSTOM_DASHBOARD_MODULE_ATTRIBUTES.LAYOUT_TYPE_ID.attributeKey],
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue && oldValue) {
      onUpdateLayout(newValue)
    }
  },
  { immediate: true }
)

provide(currentModuleStateInjectionKey, currentModuleState)

onMounted(() => {
  modulesState.value.initModuleState({
    moduleId: moduleId.value,
    state: {
      typeId: props.formModel.typeId || MODULE_TYPE_IDS.OKR,
      currentLayoutTypeId: props.formModel.layoutTypeId,
      isExportProceed: false
    }
  })
})

onBeforeUnmount(() => {
  modulesState.value.destroyModuleState(moduleId.value)
})
</script>

<style lang="scss" scoped></style>
